import React, { useEffect, useRef, useState } from 'react';
import { Skeleton, message } from 'antd';
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';
import useSWR from 'swr';
import { useLocation } from 'react-router-dom';
import { LAUNCH_FEATURES } from '../../../constants/define/translation';
import { API_URLS } from '../../../constants/urls/api-urls';
import { getLaunchFeaturesListRepository } from '../../../repository/mytm/launchFeatures/launchFeaturesRepository';
import { ContentPageHeader } from '../../molecules/page-header/ContentPageHeader';
import { LaunchFeaturesTable } from '../../organisms/misc/LaunchFeaturesTable';
import { appStyles } from '../../../styles';
import { MESSAGE_ERROR } from '../../../constants/message';
import { PAGES } from '../../../constants/urls/page-urls';

export const LaunchFeatures = () => {
  const [loading] = useState(false);
  const [mergeData, setMergeData] = useState([]);
  const { t } = useTranslation(LAUNCH_FEATURES);
  const errorCount = useRef(0);
  const location = useLocation();
  const currentPath = location.pathname;

  let apiUrl: string = '';
  let title: string = '';
  let footer: string = '';
  switch (currentPath) {
    case PAGES.PAID_FEATURES:
      title = t('header.titlePaid');
      footer = t('header.footer.paid');
      apiUrl = API_URLS.PAID_FEATURES;
      break;
    case PAGES.SHOW_HIDE_FEATURES:
      title = t('header.titleShowHide');
      footer = t('header.footer.showHide');
      apiUrl = API_URLS.SHOW_HIDE_FEATURES_LIST;
      break;
    default:
      title = t('header.title');
      footer = t('header.footer.launch');
      apiUrl = API_URLS.LAUNCH_FEATURES_LIST;
      break;
  }

  const { data, isValidating, error, mutate } = useSWR(
    [apiUrl, currentPath],
    (url: string) =>
      getLaunchFeaturesListRepository(url, {
        country: 'all',
      }),
    {
      revalidateOnFocus: false,
      refreshInterval: 600000,
    },
  );

  if (error) {
    errorCount.current += 1;
    if (errorCount.current === 1) {
      message.error(MESSAGE_ERROR.M02);
      const timeout = setTimeout(() => {
        errorCount.current = 0;
        clearTimeout(timeout);
      }, 5000);
    }
  }
  useEffect(() => {
    const transformedData: any = [];

    data &&
      Object.keys(data)?.forEach(country => {
        data[country]?.forEach((item: any) => {
          const existingItem = transformedData.find((transformedItem: any) => transformedItem.id === item.id);
          if (existingItem) {
            existingItem.countries.push(country);
            if (item.enabled) {
              existingItem.enables.push(country);
            }
          } else {
            transformedData.push({
              ...item,
              countries: [country],
              enables: item.enabled ? [country] : [],
            });
          }
        });
      });
    setMergeData(transformedData);
  }, [data]);

  /**
  
 dataSource = [
  {
    feature
  }
 ]
  
 * */

  return (
    <Container>
      <ContentPageHeader title={title} footer={footer} extra={[]} />
      {!mergeData.length && (
        <Container>
          <Skeleton active />
        </Container>
      )}
      {!!mergeData.length && (
        <LaunchFeaturesTable onRefresh={mutate} records={mergeData} loading={loading || isValidating} />
      )}
    </Container>
  );
};

const Container = styled.div`
  ${appStyles.paddingComponent}
  .ant-table-thead {
    border-bottom: 2px solid #eee;
  }
  .ant-table-thead > tr > th {
    ${appStyles.background.tableBgGray}
    text-transform: uppercase;
    font-size: 0.75rem;
    font-weight: 600;
    &:before {
      display: none;
    }
  }

  & .ant-page-header {
    padding-left: 0px;
  }
`;
